import React from 'react';
import {Field, Form, withFormik} from "formik";
import { useTranslation } from "react-i18next";
import * as yup from 'yup';
import withStyles from "@material-ui/core/styles/withStyles";
import indexesPageStyle from "assets/jss/material-dashboard-pro-react/views/indexesPageStyle.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Datetime from "react-datetime";
import { InputLabel } from '@material-ui/core';
import { PropTypes } from 'prop-types';

/*
* Validation Schema for deFormSchema
* */
const FilterOpportunityFormSchema = yup.object().shape({
  name: yup.string(),
  dateCreateIn: yup.string(),
  dateCreateEnd: yup.string()
});

const FilterOpportunityForm = (props) => {
    // Formik bag
    const {
      setFieldValue,
      submitSuccess,
      classes,
      values
    } = props;
    const { t } = useTranslation("instances");
    return (
      <Form>
        <GridContainer>
          <GridItem xs={3}>
            <InputLabel className={classes.label}>
              Fecha de creación inicio
            </InputLabel>
            <Datetime
              name={"dateCreateIn"}
              timeFormat={false}
              onChange={e => {
                let date = e;
                if (e === "") {
                  setFieldValue("dateCreateIn", e);
                } else {
                  setFieldValue("dateCreateIn", e._d);
                }
                submitSuccess({...values, dateCreateIn: date});
              }}
            />
          </GridItem>

          <GridItem xs={3}>
            <InputLabel className={classes.label}>
              Fecha de creación Final
            </InputLabel>
            <Datetime
              name={"dateCreateEnd"}
              timeFormat={false}
              onChange={e => {
                let date = e;
                if (e === "") {
                  setFieldValue("dateCreateEnd", e);
                } else {
                  setFieldValue("dateCreateEnd", e._d);
                }

                submitSuccess({...values, dateCreateEnd: date});
              }}
            />
          </GridItem>

        </GridContainer>
      </Form>
    );
}

FilterOpportunityForm.prototype = {
  setFieldValue: PropTypes.func.isRequired,
  submitForm: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
}

const FilterOpportunityFormWF = withFormik({
  validationSchema: FilterOpportunityFormSchema,
  mapPropsToValues: props => ({
    name: "",
    status: "",
    dateCreateIn: "",
    dateCreateEnd:""
  }),
  handleSubmit: (values, {props}) => {
    props.submitSuccess(values);
  },
})(withStyles(indexesPageStyle)(FilterOpportunityForm));

export default FilterOpportunityFormWF;
